import PropTypes from "prop-types";

import { Grid, Paper, Typography } from "@mui/material";

import { formatDate, formatMoney } from "@/features/shared";

export const GeneralInformationSection = ({ salesInvoice }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">
            Informasi Faktur Penjualan
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(salesInvoice.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Penjual
          </Typography>
          <Typography variant="body1">
            {salesInvoice.seller?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pembeli
          </Typography>
          <Typography variant="body1">
            {salesInvoice.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Syarat Pembayaran
          </Typography>
          <Typography variant="body1">
            {salesInvoice.paymentTerm?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Subtotal
          </Typography>
          <Typography variant="body1">
            {formatMoney(salesInvoice.subtotal)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pajak
          </Typography>
          <Typography variant="body1">
            {formatMoney(salesInvoice.taxAmount)} ({salesInvoice.taxPercentage}
            %)
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Total Diskon
          </Typography>
          <Typography variant="body1">
            {formatMoney(salesInvoice.totalDiscount)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Grand Total
          </Typography>
          <Typography variant="body1" sx={{
            fontWeight: "bold"
          }}>
            {formatMoney(salesInvoice.grandTotal)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">{salesInvoice.note ?? "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  salesInvoice: PropTypes.object.isRequired,
  buyerOutletName: PropTypes.string,
};
